let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3tzD8")).then(() => parcelRequire('7Q5hy'));